import { FunctionComponent, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Locales } from 'types/locale';

import { select as selectLocale } from 'utils/locale';
import { withVariables } from 'utils/string';

import Accordion from 'components/layout/Accordion/component';
import Categories from 'components/modules/public/layout/faq/Categories';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageFaqSectionQuestions: FunctionComponent<Props> = ({
    categories,
    posts,
}) => {
    const router = useRouter();
    const asPath = router?.asPath;
    const asPathParts = asPath.split('#');
    const hash = asPathParts[1] || null;

    let activeCategorySlug = router.query?.slug?.toString();
    const search = router.query?.search?.toString();
    const isEmpty = posts.elements?.length === 0 && !activeCategorySlug;

    const [activeId, setActiveId]: [string, Function] = useState(hash || null);

    const translations = selectLocale({
        [Locales.Pl]: require('./locales/pl.json'),
    });

    useEffect(() => {
        const asPath = router?.asPath;
        const asPathParts = asPath.split('#');
        const nextAsPath = asPathParts[0] || '';

        if (activeId) {
            router.push(withVariables(nextAsPath, {}, {}, `#${activeId}`));
        } else {
            router.push(withVariables(nextAsPath, {}, {}, ''));
        }
    }, [activeId]);

    if (!activeCategorySlug && !search) {
        const firstCategory = categories.elements?.length > 0
            ? categories.elements[0]
            : null;
        if (firstCategory) {
            activeCategorySlug = firstCategory?.slug;
        }
    }

    return (
        <StyledComponent className="public-page-faq-section-questions">
            <div className="col col-categories">
                {!isEmpty && (
                    <Categories
                        categories={categories.elements}
                        activeCategorySlug={activeCategorySlug}
                    />
                ) }
            </div>
            <div className="col col-content">
                <div className="accordion-list">
                    {isEmpty ? (
                        <p
                            className="is-empty"
                            dangerouslySetInnerHTML={{ __html: translations?.isEmpty }}
                        />
                    ) : posts.elements.map(element => (
                        <div
                            key={element.id}
                            id={element.id}
                            onClick={() => setActiveId(activeId === element.id
                                ? null
                                : element.id
                            )}
                        >
                            <Accordion
                                summary={element.title}
                                details={element.content}
                                active={activeId === element.id}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicPageFaqSectionQuestions;